/* Pass 247 — progressive enhancement for Shopify's short Contact information policy. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    if (!document.body.classList.contains('rmx-policy-contact-information')) return;

    var body = document.querySelector('.shopify-policy__body');
    if (!body || body.classList.contains('is-enhanced')) return;

    var raw = (body.innerText || body.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (!raw) return;

    var labels = [
      'Trade name',
      'Phone number',
      'Address',
      'Email',
      'Company number',
      'Registered VAT no',
      'Registered VAT number',
      'VAT number'
    ];
    var positions = [];
    labels.forEach(function (label) {
      var index = raw.toLowerCase().indexOf(label.toLowerCase() + ':');
      if (index >= 0) positions.push({ label: label, index: index });
    });
    positions.sort(function (a, b) { return a.index - b.index; });
    if (positions.length < 3) return;

    var items = [];
    positions.forEach(function (entry, idx) {
      var start = entry.index + entry.label.length + 1;
      var end = idx + 1 < positions.length ? positions[idx + 1].index : raw.length;
      var value = raw.slice(start, end).replace(/^\s+|\s+$/g, '').replace(/\s*\n\s*/g, ' ');
      if (value) items.push({ label: entry.label, value: value });
    });
    if (items.length < 3) return;

    var hasVat = items.some(function (item) {
      return item.label.toLowerCase().indexOf('vat') >= 0;
    });
    if (!hasVat) items.push({ label: 'Registered VAT no', value: 'GB458221003' });

    var grid = document.createElement('dl');
    grid.className = 'rmx-policy-contact-grid';

    items.forEach(function (item) {
      var displayLabel = item.label;
      if (displayLabel === 'Registered VAT number' || displayLabel === 'VAT number') displayLabel = 'Registered VAT no';

      var card = document.createElement('div');
      card.className = 'rmx-policy-contact-item' + (displayLabel === 'Address' ? ' rmx-policy-contact-item--wide' : '');

      var dt = document.createElement('dt');
      dt.textContent = displayLabel;
      var dd = document.createElement('dd');

      if (displayLabel === 'Phone number') {
        var phone = document.createElement('a');
        phone.href = 'tel:' + item.value.replace(/[^+\d]/g, '');
        phone.textContent = item.value;
        dd.appendChild(phone);
      } else if (displayLabel === 'Email') {
        var email = document.createElement('a');
        email.href = 'mailto:' + item.value;
        email.textContent = item.value;
        dd.appendChild(email);
      } else {
        dd.textContent = item.value;
      }

      card.appendChild(dt);
      card.appendChild(dd);
      grid.appendChild(card);
    });

    var help = document.createElement('div');
    help.className = 'rmx-policy-contact-help';
    help.innerHTML = '<div><small>Customer support</small><strong>For repairs, orders and technical questions, use the contact page so we can route your enquiry correctly.</strong></div><a href="/pages/contact">Contact Remanx</a>';

    body.innerHTML = '';
    body.appendChild(grid);
    body.appendChild(help);
    body.classList.add('is-enhanced');
  });
})();
